/**
 * 🏗️ Sprint 3: Centralized Time Constants
 * 
 * Eliminates magic numbers for time-related values
 */

// Base time units in milliseconds
export const MS_PER_SECOND = 1000;
export const MS_PER_MINUTE = 60 * MS_PER_SECOND;
export const MS_PER_HOUR = 60 * MS_PER_MINUTE;
export const MS_PER_DAY = 24 * MS_PER_HOUR;

// Intervals for background tasks
export const INTERVALS = {
  /** PWA update check - 15 minutes */
  PWA_UPDATE_CHECK: 15 * MS_PER_MINUTE,
  /** Service Worker check - 1 minute */
  SERVICE_WORKER_CHECK: MS_PER_MINUTE,
  /** Activity feed refresh - 10 seconds */
  ACTIVITY_FEED_REFRESH: 10 * MS_PER_SECOND,
  /** Motivational phrase rotation - 1 minute */
  MOTIVATIONAL_PHRASE: MS_PER_MINUTE,
} as const;

// Cache times for React Query
export const CACHE_TIMES = {
  DEFAULT: {
    staleTime: 5 * MS_PER_MINUTE,
    gcTime: 10 * MS_PER_MINUTE,
  },
  SHORT: {
    staleTime: 2 * MS_PER_MINUTE,
    gcTime: 5 * MS_PER_MINUTE,
  },
  LONG: {
    staleTime: 30 * MS_PER_MINUTE,
    gcTime: 60 * MS_PER_MINUTE,
  },
  /** 🚀 Materialized Views: dados pré-calculados, cache mais agressivo */
  MATERIALIZED_VIEW: {
    staleTime: 10 * MS_PER_MINUTE,
    gcTime: 30 * MS_PER_MINUTE,
  },
} as const;

// Session durations
export const SESSION_DURATION = {
  /** Student session - 24 hours */
  STUDENT: MS_PER_DAY,
} as const;
